package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.JustifyContent

@Composable
internal fun PageErrorContent(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<PageErrorContentKind>? = null,
    errorMessage: String? = null,
    content: (@Composable () -> Unit)? = null
) {
    Box(
        modifier = PageErrorContentStyle.toModifier(variant).then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        SpanText("Something went wrong...", modifier = ExuraTextStyle.toModifier(ExuraSectionHeaderTextVariant))

        errorMessage?.let { message ->
            SpanText(message, ExuraTextStyle.toModifier(ExuraBodyHeaderTextVariant))
        }
        content?.invoke()
    }
}


sealed interface PageErrorContentKind : ComponentKind

val PageErrorContentStyle = CssStyle<PageErrorContentKind> {
    base {
        Modifier
            .fillMaxSize()
            .justifyContent(JustifyContent.Center)
    }
}
